import PurchaseOrderActions from "./PurchaseOrderActions";
import "./InventoryCountActions.css";

// Use the same grouped action disclosure as purchase orders. The count
// workspace handles Escape at document capture, so this layer owns it first.
export default function InventoryCountActions({ label, groups, disabled = false }) {
  return <div className="ic-sessionActionsDropdown">
    <PurchaseOrderActions label={label} groups={groups} disabled={disabled}
      triggerClassName="ic-btn ic-btn--ghost" captureEscape />
  </div>;
}
